import * as React from 'react';
import { MenuItem, styled } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { SelectInput as BaseSelectInput } from 'src/components/Forms/FormInputs/styled';

interface SelectProps {
  name: string;
  options: { label: string; key: string }[];
  placeholder?: string;
  onManualChange?: () => void;
  disabled?: boolean;
}

// ⬇️ Estendi lo stile base per gestire il colore grigio del placeholder
const StyledSelectInput = styled(BaseSelectInput)(({ theme }) => ({
  '&.placeholder': {
    color: theme.palette.text.disabled,
  },
}));

export const Select: React.FC<SelectProps> = ({
  name,
  options,
  placeholder,
  onManualChange,
  disabled = false,
}) => {
  const [open, setOpen] = React.useState(false);
  const { control } = useFormContext();

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { onChange, onBlur, value } }) => (
        <StyledSelectInput
          open={open}
          value={value}
          onOpen={handleOpen}
          onClose={handleClose}
          onBlur={onBlur}
          onChange={(e) => {
            onChange(e);
            onManualChange?.();
          }}
          disabled={disabled}
          displayEmpty
          className={value === '' ? 'placeholder' : ''}
        >
          <MenuItem value="" disabled sx={{ color: 'text.disabled' }}>
            {placeholder || 'Seleziona un’opzione'}
          </MenuItem>
          {options.map((option) => (
            <MenuItem key={option.label} disableRipple value={option.key}>
              {option.label}
            </MenuItem>
          ))}
        </StyledSelectInput>
      )}
    />
  );
};
// finish!
